<template>
    <div>
        <div v-if="loadingHistory" class="pa-5 d-flex align-center justify-center">
            <loader/>
        </div>
        <div v-else-if="!history || !history.length" class="pa-2 text-overline grey--text text-center">
            No Status History
        </div>
        <div v-else>
            <v-data-table
                :items="history"
                :headers="headers"
                dense
            >
                <template #item.date="{item}">
                    {{format(new Date(item.date), 'yyyy-MM-dd hh:mm')}}
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {waitForEvent} from "../../../core/socket";
import {validationRules} from "../../../core/codeFunctions";
import Loader from "@/components/General/Loader/Loader.vue";
import {format} from "date-fns";

export default {
    components: {Loader},
    props: {
        fkEmp: Number
    },
    data() {
        return {
            format,
            loadingHistory: false,
            history: null,
            headers: [
                {value: "date", text: "Date"},
                {value: "name", text: "Status"},
            ]
        }
    },
    watch: {

        fkEmp: {
            immediate: true,
            handler() {
                this.initHistory();
            }
        }

    },
    methods: {


        async initHistory() {
            try {
                this.loadingHistory = true;
                this.history = await this.$newReq("POST",'setup/emp/statusHistory', {id: this.fkEmp})
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.loadingHistory = false
            }
        },

    },
    computed: {
        ...mapGetters(['barcodes', 'barcodesLookup']),
    },
}
</script>

<style scoped>

</style>